// ** Third Party Components
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ReactCountryFlag from 'react-country-flag';

// ** Reactstrap Imports
import {
  ReactstrapDropdown as Dropdown,
  ReactstrapDropdownMenu as DropdownMenu,
  ReactstrapDropdownItem as DropdownItem,
  ReactstrapDropdownToggle as DropdownToggle
} from '@febos-io/design';
import { changeLanguage } from '../../../../../config';

function IntlDropdown() {
  // ** Hooks
  const { i18n, } = useTranslation();
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const toggle = () => setDropdownOpen((prevState) => !prevState);

  // ** Function to switch Language
  const handleLangUpdate = (e, lang) => {
    e.preventDefault();
    changeLanguage(lang);
  };

  const actualFlag = useMemo(() => {
    let language = i18n.language;
    if (language.indexOf('-') > -1) {
      language = language.split('-')[0];
    }
    if (language === 'en') {
      return 'us';
    }
    return language;
  }, [i18n.language]);

  return (
    <Dropdown
      isOpen={dropdownOpen}
      toggle={toggle}
      className="dropdown-language nav-item"
    >
      <DropdownToggle
        tag="a"
        className="nav-link"
        onClick={e => e.preventDefault()}
      >
        <ReactCountryFlag
          svg
          className="country-flag flag-icon"
          countryCode={actualFlag}
        />
      </DropdownToggle>
      <DropdownMenu
        className="mt-0"
        // end
      >
        <DropdownItem
          onClick={e => handleLangUpdate(e, 'en')}
        >
          <ReactCountryFlag
            className="country-flag"
            countryCode="us"
            svg
          />
          <span className="ms-1">English</span>
        </DropdownItem>
        <DropdownItem
          onClick={e => handleLangUpdate(e, 'es')}
        >
          <ReactCountryFlag
            className="country-flag"
            countryCode="es"
            svg
          />
          <span className="ms-1">Español</span>
        </DropdownItem>
      </DropdownMenu>
    </Dropdown>
  );
}

export default IntlDropdown;
